import React from 'react';

/**
 * Skeleton loader específico para el header del menú
 */
const HeaderSkeletonLoader: React.FC = () => {
  return (
    <div className="bg-[#22B6B2] dark:bg-[#2C4358] px-4 py-3">
      <div className="flex items-center justify-between">
        {/* Left section skeleton */}
        <div className="flex items-center">
          <div className="w-8 h-8 bg-white/20 rounded-lg animate-pulse"></div>
        </div>
        
        {/* Center section skeleton */}
        <div className="flex-1 mx-4">
          <div className="h-8 bg-white/20 rounded-lg animate-pulse"></div>
        </div>
        
        {/* Right section skeleton */}
        <div className="flex items-center space-x-3">
          <div className="w-16 h-6 bg-white/20 rounded animate-pulse"></div>
          <div className="w-10 h-10 bg-white/20 rounded-full animate-pulse relative">
            {/* Badge skeleton */}
            <div className="absolute -top-1 -right-1 w-5 h-5 bg-white/30 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSkeletonLoader; 